import { Component } from "react";
import { setCoverSummary } from "../../actions/cover/CoverActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

export function mapDispatchToProps(dispatch) {
  return {
    setCoverSummary: (membershipNumber, history, securityId) =>
      dispatch(setCoverSummary(membershipNumber, history, securityId))
  };
}

export function mapStateToCoverSummaryRequired(state, props) {
  const selectedPolicy =
    state && state.policyReducer && state.policyReducer.selectedPolicy;

  const member =
    selectedPolicy &&
    selectedPolicy.Members &&
    selectedPolicy.Members.find(
      (m) =>
        (props.securityId && m.SecurityId === props.securityId) ||
        (!props.securityId && m.IsLoggedInMember)
    );

  return {
    members: selectedPolicy && selectedPolicy.coverMembersList,
    membershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    member
  };
}
export class CoverSummaryRequired extends Component {
  componentDidMount() {
    if (
      this.props.members === undefined ||
      (this.props.member && !this.props.member.PlanDates)
    ) {
      this.props.setCoverSummary(
        this.props.membershipNumber,
        this.props.history,
        this.props.securityId
      );
    }
  }

  componentDidUpdate() {
    if (
      this.props.members === undefined ||
      (this.props.member && !this.props.member.PlanDates)
    ) {
      this.props.setCoverSummary(
        this.props.membershipNumber,
        this.props.history,
        this.props.securityId
      );
    }
  }

  render() {
    return this.props.members === undefined ||
      (this.props.member && !this.props.member.PlanDates)
      ? null
      : this.props.children;
  }
}

export default withRouter(
  connect(
    mapStateToCoverSummaryRequired,
    mapDispatchToProps
  )(CoverSummaryRequired)
);
